<div class="w-100 h-100">
  <router-outlet #outlet="outlet"></router-outlet>
</div>